export default __webpack_public_path__ + "7ccd700d1bbb7b1ab3abea5149f0c510.png";